export default "__VITE_ASSET__DZ3SD9Sx__"